import store from '../store'
const accountTypes = [
    {
        accountKey: 'jl2k34hj23hF4Gjl2k34hj23hF',
        accountName: 'FREE PLAN'
    },
    {
        accountKey: 'hGjl234dhF4Gjl2kG48A0dffFS',
        accountName: 'TRIAL PLAN'
    },
    {
        accountKey: 'hF4Gjl2khF4Gjl2khF4Gjl2kS',
        accountName: 'STANDARD PLAN'
    },
    //add other paid plans
]
export default {
    getData() {
        return accountTypes.filter(x => x.accountKey == store.state.companyAccount.accountKey)
    },
    isFreePlan() {
        const data = this.getData()
        if (store.state.companyAccount && data && data.length) {
            return data[0].accountName == 'FREE PLAN'
        } 
    },
    isTrialPlan() {
        const data = this.getData()
        if (store.state.companyAccount && data && data.length) {
            return data[0].accountName == 'TRIAL PLAN'
        } 
    },
    isPaidPlan() {
        return !this.isFreePlan() && !this.isTrialPlan()
    },
    isExpiredAccount() {
        return store.state.companyAccount.isExpiredAccount
    },
    isPaymentOverdue() {
        return store.state.companyAccount.isPaymentOverdue
    },
    planName() {
        if (this.isExpiredAccount()) {
            return 'EXPIRED ACCOUNT'
        }
        const data = this.getData()
        if (data && data.length) {
            return data[0].accountName
        }
    }
}